export const environment = {
    production: false,
    apiUrl: 'https://api.le-dressing.qual.cawita.com',
    assetUrl: 'https://assets.le-dressing.qual.cawita.com',
    customerSpaceUrl: 'https://share.le-dressing.qual.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};